
import { useState, useEffect } from 'react';
import { getUnitSymbol } from '@/types/unit-types';
import { useUnitOptions } from '@/components/internal/line-items/hooks/useUnitOptions';

interface EnhancedUnitResolution {
  getUnitSymbolWithCustom: (unit: string) => string;
  isLoading: boolean;
}

export const useEnhancedUnitResolution = (companyId?: string): EnhancedUnitResolution => {
  const { customUnitOptions, loading } = useUnitOptions(companyId);
  const [unitMap, setUnitMap] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    const newUnitMap = new Map<string, string>();
    
    // Add custom units first (higher priority)
    customUnitOptions.forEach(unit => {
      newUnitMap.set(unit.value, unit.symbol);
    });
    
    setUnitMap(newUnitMap);
  }, [customUnitOptions]);

  const getUnitSymbolWithCustom = (unit: string): string => {
    if (!unit) return '';
    
    // First check custom units
    const customSymbol = unitMap.get(unit);
    if (customSymbol) {
      return customSymbol;
    }
    
    // Fall back to system units
    return getUnitSymbol(unit);
  };

  return {
    getUnitSymbolWithCustom,
    isLoading: loading
  };
};
